export const DAY_OF_WEEK_REPORT_ID = 'day-of-week';
